import { CheckCircle2, XCircle } from "lucide-react";
import { rp, pct, fmtDate } from "../../lib/format";

const Row = ({ k, v, strong, testid }) => (
  <div className="flex items-center justify-between gap-4 px-4 py-2.5 text-sm odd:bg-[#F5F6FA]">
    <span className="text-slate-500">{k}</span>
    <span className={`lp-num text-right font-semibold ${strong ? "text-[#351080]" : "text-[#17223B]"}`} data-testid={testid}>{v}</span>
  </div>
);

const Block = ({ title, accent, children }) => (
  <div>
    <p className="mb-2 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.12em] text-[#351080]">
      <span className="h-3 w-[3px] rounded" style={{ background: accent }} />{title}
    </p>
    <div className="overflow-hidden rounded-lg border border-slate-100">{children}</div>
  </div>
);

export default function ResultView({ r }) {
  return (
    <div className="space-y-6" data-testid="final-result">
      <div className="grid gap-6 md:grid-cols-2">
        <div className="space-y-6">
          <Block title="Identitas Debitur" accent="#351080">
            <Row k="Nama Debitur" v={r.name} /><Row k="Tanggal Proses" v={fmtDate(r.process_date)} />
            <Row k="Usia" v={`${r.age} tahun`} /><Row k="Kategori Produk" v={r.category} strong testid="result-category" />
          </Block>
          <Block title="Parameter Pengajuan" accent="#F28A19">
            <Row k="Plafond" v={rp(r.plafond)} testid="result-plafond" /><Row k="Tenor" v={`${r.tenor} bulan`} />
            <Row k="Bunga Bank" v={`${pct(r.bank_rate)} per tahun`} /><Row k="Bunga Koperasi" v={`${pct(r.coop_rate)} per tahun`} />
            <Row k="Gaji Bulanan" v={rp(r.salary)} /><Row k="Nilai Take Over" v={rp(r.take_over)} /><Row k="Tata Laksana" v={pct(r.tata_laksana_pct)} />
          </Block>
          <Block title="Rincian Angsuran" accent="#5720B8">
            <Row k="Angsuran Bank per Bulan" v={rp(r.bank_installment)} testid="result-bank-installment" />
            <Row k="Angsuran Koperasi per Bulan" v={rp(r.coop_installment)} strong testid="result-coop-installment" />
            <Row k="BAA per Bulan" v={rp(r.baa)} testid="result-baa" /><Row k="Rasio Angsuran Aktual" v={pct(r.ratio_pct)} testid="result-ratio" />
          </Block>
        </div>
        <div className="space-y-6">
          <Block title="Rincian Biaya Kredit" accent="#5720B8">
            <Row k={`Biaya PROAQ (${pct(r.proaq_pct)})`} v={rp(r.proaq)} testid="result-proaq" />
            <Row k={`Cadangan Risiko (${pct(r.risk_pct)})`} v={rp(r.risk)} testid="result-risk" />
            <Row k="Biaya Administrasi" v={rp(r.admin_fee)} testid="result-admin" />
            <Row k={`Biaya Tata Laksana (${pct(r.tata_laksana_pct)})`} v={rp(r.tata_laksana_fee)} testid="result-tl" />
            <Row k="Total Biaya Kredit" v={rp(r.total_fees)} strong testid="result-total-fees" />
          </Block>
          <Block title="Rincian Pengurang Pencairan" accent="#F28A19">
            <Row k="Total Biaya Kredit" v={rp(r.total_fees)} /><Row k="Nilai Take Over" v={rp(r.take_over)} />
            <Row k="Retensi Angsuran (3× angsuran koperasi)" v={rp(r.retention)} testid="result-retention" />
          </Block>
          <Block title="Validasi" accent="#078D67">
            {r.validations.map((v) => (
              <div key={v.key} className={`flex items-center justify-between px-4 py-2 text-sm odd:bg-[#F5F6FA] ${v.key === "overall" ? "font-bold" : ""}`} data-testid={`validation-${v.key}`}>
                <span className="text-slate-600">{v.label}</span>
                <span className={`flex items-center gap-1 font-semibold ${v.ok ? "text-[#078D67]" : "text-red-600"}`}>
                  {v.ok ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}{v.ok ? "Sesuai" : "Tidak Sesuai"}
                </span>
              </div>
            ))}
          </Block>
        </div>
      </div>
      <div className="grid gap-px overflow-hidden rounded-xl bg-[#351080] sm:grid-cols-2">
        <div className="p-5 text-white"><p className="text-xs text-white/70">Hasil Pencairan — Sisa Pencairan Bersih</p><p className="mt-1 font-display text-3xl font-bold lp-num" data-testid="result-net">{rp(r.net_disbursement)}</p></div>
        <div className="p-5 text-white sm:border-l sm:border-white/15"><p className="text-xs text-white/70">Sisa Gaji setelah Angsuran Koperasi</p><p className="mt-1 font-display text-3xl font-bold lp-num" data-testid="result-remaining-salary">{rp(r.remaining_salary)}</p></div>
      </div>
    </div>
  );
}
